import http from '@/utils/http';

// can be removed from AddUpdateExtensionAppModal once https://pendo-io.atlassian.net/browse/APP-50592 is completed
export function fetchFullSubscription () {
    return http.get('/api/s/_SID_/subscription').then((res) => res.data);
}
